import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { RequestFormService } from 'src/app/home/services/request-form.service';
import { CommmonService } from 'src/app/utils/common.service';
import { UtilsNotificationService } from 'src/app/utils/utils-notification.service';
import { FORM_TYPE_KEY } from '../../benefit-application/utils/constants/constats';
import { DataFormService } from 'src/app/reference-data/service/dataForm.service';
@Component({
  selector: 'app-modal-downgrade',
  templateUrl: './modal-downgrade.component.html',
  styleUrls: ['./modal-downgrade.component.scss'],
})
export class ModalDowngradeComponent {
  @Input() titleplan!: string;
  @Input() imagen!: string | undefined;
  @Input() iconplan!: string;
  @Input() description!: string | undefined;
  @Input() process!: string | undefined;
  @Input() idplan!: number;
  @Input() miplan!: number;
  @Input() nombreMiPlan!:string;
  @Input() cambioAplanDuo!:boolean;

  @Output() closeModalPlan = new EventEmitter();
  @Output() openModaldesaffiliation = new EventEmitter();

  employeeSap:any;
  isCopecEmployee=false;
  mensajeModal = ''
  iconoModal = ''
  openModalAlertDonwgrade = false;
  cargasSap:any;
  id_beneficio=''
  beneficiarios = new FormControl<string | null>(null, Validators.required);
  estaVacio = false;
  spinner = false;
  active_user :any = {}

constructor(
    private router: Router,
    private utilsService: UtilsNotificationService,
    private requestFormService: RequestFormService,
    private commonService: CommmonService,
    private route: ActivatedRoute,
    private dataFormService: DataFormService,
  ) {}
  
  async ngOnInit(){
    this.obtenerDatosEmpleadoSAP()
    this.getIdBenefitCambioPlan() 
    this.active_user =  JSON.parse(this.commonService.getItemSessionStorage('id_token_claims_obj') ?? '{}');
    this.cargasSap = this.employeeSap.colaborador.beneficiarios.filter((x: any) =>
        x.tipo.detalle === 'Conviviente Civil' ||
        x.tipo.detalle === 'Pareja' ||
        x.tipo.detalle === 'Cónyuge' ||
        x.tipo.detalle === 'Padre' ||
        x.tipo.detalle === 'Madre' 
    );
   
  }

  
  async obtenerDatosEmpleadoSAP(){
    const sap = this.route.snapshot.data['resolverEmpleadoSAP']; 
    this.employeeSap = sap;
    if(sap){
      this.isCopecEmployee = true;
    }
  }

  getIdBenefitCambioPlan(){
    const benefits = this.commonService.sortArray(
     this.route.snapshot.data['resolverBenefit'] ?? [],
   ); 
    const cambio_plan = benefits.length === 0
     ? undefined
     : benefits.find((b: any) => b.title === "Cambio de Plan");
  
   this.id_beneficio = cambio_plan.id  
 }

 solicitaCambioPlan(event:any){
  if(event){
    this.openModalAlertDonwgrade=false;
  this.gestionSolicitudDowngrade()
  }
 }
  
  closeModal() {
    this.closeModalPlan.emit(false);
  }

  successView() { 
    if(this.idplan === 3){ 
        // si es cambio a plan duo se gestiona su flujo.
      if(this.beneficiarios.invalid){
        this.mensajeModal = 'alertaPlanDuo'
        this.iconoModal = 'alerta'
      this.openModalAlertDonwgrade =true;
      }else{  
        this.gestionSolicitudDowngrade()
      }
    }
    else{ // si no es cambio a plan duo se gestiona el envio de la solicitud
      this.gestionSolicitudDowngrade()
    }
    
  }

   gestionSolicitudDowngrade(){
      const colaborador = this.employeeSap.colaborador
      let formulario = this.armaFormularioTrabajador(colaborador);
      let informacionBancaria = this.armaInformacionBancaria(colaborador)
      let informacionBeneficiario = this.armaInfoBeneficiario(colaborador)
      this.postSolicitud(formulario, informacionBancaria, informacionBeneficiario)
  }


  closeModalAlert(event:any){
    this.openModalAlertDonwgrade= event;
  }

   async armaFormularioTrabajador(colaborador:any){    
   
    let maritalStatus = await this.dataFormService.getmaritalStatus();
    let genders = await this.dataFormService.getGenders();
    let regions = await this.dataFormService.getRegions();
    
    const region = regions.find(x => x.id.includes(colaborador.direccion.region));
    const genero = genders.find(x=>x.id.includes(colaborador.sexo));
    const estadoCivil = maritalStatus.find(x=>x.id.includes(colaborador.estadoCivil))
      
    const comuna =  region.communes.find((x:any )=> x.id === parseInt(colaborador.direccion.comuna))
    
      const payload = {
          Nombres:colaborador.nombres,
          Apellido_Paterno: colaborador.apellidoPaterno,
          Apellido_Materno:colaborador.apellidoMaterno,
          RUT: colaborador.rut,
          Teléfono: colaborador.telefono,
          Fecha_Nacimiento:this.utilsService.formatDateSAP(colaborador.fechaNacimiento),
          Email:this.active_user ? this.active_user.email : colaborador.emailCorporativo ,
          Genero:genero.name,
          Estado_civil:estadoCivil.name,
          Región:region.regionName,
          Comuna:comuna ? comuna.name : "",
          Calle:colaborador.direccion.direccion,
          Número:colaborador.direccion.numero, 
          Tipo:colaborador.direccion.tipo,
          Actividad:"",
          Hobby:"" 
      }
      
      const formData = this.utilsService.transformFormSeguroSaludDental(payload)
      
      return formData
     
    }


    async armaInformacionBancaria(colaborador:any){
      if(this.idplan !== 1){
        const banks =  await this.dataFormService.getBanks();
        const accountTypes = await this.dataFormService.getAccountype();
        
        colaborador.bancarios[0].tipoCuenta = this.utilsService.accountTypeBeneficiare(colaborador.bancarios[0].tipoCuenta, accountTypes) 
        colaborador.bancarios[0].idBanco = this.utilsService.bankBeneficiare(colaborador.bancarios[0].idBanco, banks)
      
        const formdata = this.utilsService.transformFormSeguroSaludDental(colaborador.bancarios[0]); 
        const payloadInfo = {
          Banco :formdata.idBanco,
          Tipo_de_cuenta :formdata.tipoCuenta,
          Número_de_cuenta :formdata.numeroCuenta,
        }
        
          return payloadInfo
      } return {}    
    }
  
    armaInfoBeneficiario(colaborador:any, ){ 
      if(this.idplan === 3 && this.beneficiarios.value !== null){ 
        let beneficiario = colaborador.beneficiarios.find((x:any) => x.rut === this.beneficiarios.value); 
        const rut_sin_puntos = this.utilsService.cleanRut(beneficiario.rut)
        let beneficiarios = {
          Nombres:beneficiario.nombres,
          Apellido_Paterno:beneficiario.apellidoPaterno,
          Apellido_Materno:beneficiario.apellidoMaterno,
          Fecha_de_Nacimiento:this.utilsService.formatearFecha(beneficiario.fechaNacimiento),
          rut:rut_sin_puntos,
          Parentesco:beneficiario.tipo.detalle,
          Previsión:""
        }
        const datosBeneficiarios = this.utilsService.transformFormSeguroSaludDental(beneficiarios)
        
        return [datosBeneficiarios];
    }
    return []
  }
  
    async postSolicitud(infoPersonal:any, infoBancaria:any, beneficiario:any){
      this.spinner = true;
 
       const payload = {
        informacion_personal: await infoPersonal,
        informacion_bancaria: await infoBancaria,
        beneficiarios: await beneficiario,
        direccion: {},
        informacion_adicional: {
          Plan_proveniente: {index:1 , valor:this.nombreMiPlan},
          Solicita_cambio_a:{index:2 , valor:this.titleplan}
        },
       
        preExistences:[],
        esCambioPlan:{
          esCambioPlan : true,
          idPlanCambio: this.idplan,
          idPlanAnterior:this.miplan
        },
        cargasNueva:[],
        hijoNietoMayorEdad:[],        
        observaciones:"",
        atributos_corregir: {
          motivo_correccion: '',
          comentario_correccion: '',
          campos_corregir: [],
        },
        motivo_rechazo: '',
        historial_diferente:true,
        mensaje_historial:"[nombre_empleado] ha enviado una solicitud para Cambio de Plan",
        formulario: FORM_TYPE_KEY.FRM_CAMBIO_PLAN,
        
      };
       
      this.formBenefits_post_cambioPlan(payload);
    }
  
    async formBenefits_post_cambioPlan(form: any) {
      
      try {
        const request = {
          beneficio_id: this.id_beneficio,
          estado_solicitud_id: 1,
          formulario: JSON.stringify(form),
        };
  
        await this.requestFormService
          .postRequestForms(request)
          .then((response: any) => {
            if (response?.statusCode === 200) {
              this.spinner = false
              this.router.navigate(['/successful-request', { success: true }]);
              this.closeModal();            
            }
          });
      } catch (error: any) {
        this.spinner = false
        this.router.navigate(['/successful-request', { success: false }]);
        this.closeModal(); 
      }
    
    }



}
